import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Card from "../card/Card";
import Informations from "../informations/Informations";
import SocialNetwork from "../socialNetwork/SocialNetwork";
import { addByIncrement } from "../../store/reducers/cartSlice";
import { useFetchProductByIdQuery } from "../../store/api/ProductSlice";
import DOMPurify from "dompurify";
import { combineSlices } from "@reduxjs/toolkit";
import SEO from "../../pages/SEO";
function Product() {
  const [total, setTotal] = useState(1);
  const { id } = useParams();
  const { data, isLoading } = useFetchProductByIdQuery(id);
  const product = data;
const tags = Array.isArray(product?.tag) && product.tag.length > 0
  ? product.tag[0].split(',').map(tag => tag.trim())
  : [];


 

  const [selectedNicotineLevel, setSelectedNicotineLevel] = useState("");
  const [selectedImage, setSelectedImage] = useState(product?.image?.[0] || "");
  const [selectedAttributes, setSelectedAttributes] = useState({});

  const handleNicotineLevelChange = (e) => {
    setSelectedNicotineLevel(e.target.value);
  };

  const RelatedProduct = [];
const sanitizedDescription = DOMPurify.sanitize(
  (product?.description || "")
    .replace(/\\n/g, "\n")
    .replace(/\\r|\\t/g, "")
    .replace(/Â/g, "")
    .replace(/<a [^>]+>(.*?)<\/a>/gi, "$1")
    .replace(/<\/?h[1-6]>/gi, (match) =>
      match.startsWith("</") ? "</h6>" : "<h6>"
    )
    .replace(/\n{2,}/g, "\n")
    .split("\n")
    .map((line) => {
      const trimmed = line.trim();
      if (
        trimmed &&
        trimmed.length < 80 &&
        !trimmed.includes(".") &&
        !/<.*?>/.test(trimmed)
      ) {
        return `<li>${trimmed}</li>`;
      }
      return `<p>${trimmed}</p>`;
    })
    .join("")
    .replace(/(<li>.*?<\/li>)+/g, (match) => `<ul>${match}</ul>`)
);



  function stripHtml(html) {
    if (!html) return "";
    return html
       .replace(/\\n/g, "") // Remove double-escaped \n
      .replace(/\\r/g, "") // Remove double-escaped \r
      .replace(/\\t/g, "") // Remove tabs
      .replace(/Â/g, "")
      .replace(/\s{2,}/g, " ") // Collapse multiple spaces
      .replace(/\n+/g, "") // Remove real newlines (we'll format cleanly ourselves)
       .replace(/<a [^>]+>(.*?)<\/a>/gi, "$1")
      .replace(/<\/?h[1-6]>/gi, (match) =>
        match.startsWith("</") ? "</h6>" : "<h6>"
      )
      .trim();

  }
  const plainDescription = stripHtml(product?.description);

  function stripHtml(html) {
  if (!html) return "";

  // Remove any HTML tags
  const withoutTags = html
    .replace(/<[^>]+>/g, "")         // Remove all tags like <p>, <div>, etc.
    .replace(/&nbsp;/gi, " ")        // Replace &nbsp; with space
    .replace(/\\[nrt]/g, "")         // Remove \n, \r, \t (escaped)
     .replace(/Â/g, "")
    .replace(/\s{2,}/g, " ")         // Collapse multiple spaces
    .replace(/^\s+|\s+$/g, "")       // Trim start and end whitespace
    .replace(/\n+/g, " ");           // Replace real newlines with space

  // Optional: Remove non-content lines (like price, stock)
  const cleanedLines = withoutTags
    .split("\n")
    .map(line => line.trim())
    .filter(line =>
      line && !/^\$?\d+(\.\d+)?$/.test(line) // Remove price lines
           && !/in stock/i.test(line)       // Remove stock lines
           && !/^\s*$/g.test(line)          // Remove empty
    );

  return cleanedLines.join(" ");
}
<button style={{opacity: 0, position: 'absolute'}}>Hidden Focus</button>

  const plainDescription2 = stripHtml(product?.short_description);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const dispatch = useDispatch();
const handleAddToCart = (product) => {
  const requiredAttributes = product?.attributes || [];

  const allSelected = requiredAttributes.every(
    (attr) => selectedAttributes[attr.name]
  );

  if (!allSelected) {
    alert("Please select all attribute options.");
    return;
  }

  if (product?.nicotineLevel?.trim() && !selectedNicotineLevel) {
    alert("Please select a nicotine level.");
    return;
  }

  const formattedAttributes = Object.entries(selectedAttributes).map(
    ([name, value]) => ({
      name,
      value: [value], // put selected value in array
    })
  );

  const productWithSelections = {
    ...product,
    selectedNicotineLevel,
    attributes: formattedAttributes,
  };

  dispatch(
    addByIncrement({
      product: productWithSelections,
      cartQuantity: total,
    })
  );
 

};


  useEffect(() => {
    if (Array.isArray(product?.image) && product.image.length > 0) {
      setSelectedImage(product.image[0]);
    }
  }, [product]); // Runs when `product` changes

  return (
    <div className="bg-gray-50">
       <SEO
        title={`${product?.title} | Pufframa`}
        description={product?.description}
        image={product?.image}
        url={`https://pufframa.com/product/${product?.slug}`}
        keywords={`${product?.title}, ${product?.category}, Pufframa, buy ${product?.title}`}
        structuredData={{
          "@context": "https://schema.org/",
          "@type": "Product",
          name: product?.name,
          image: product?.image,
          description: product?.description,
          sku: product?.sku,
          brand: {
            "@type": "Brand",
            name: "Pufframa",
          },
          offers: {
            "@type": "Offer",
            url: `https://pufframa.com/product${product?.slug}`,
            priceCurrency: "USD",
            price: product?.price,
            availability: product?.inStock ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
          },
        }}
      />

      {!isLoading && (
        <div className="px-0 py-10 lg:py-10">
          <div className="mx-auto px-3 lg:px-10 max-w-screen-2xl">
            <div className="flex items-center pb-4">
              {/* <ol className="flex items-center w-full overflow-hidden">
                <li className="text-sm pr-1 transition duration-200 ease-in cursor-pointer  font-semibold">
                  <Link
                    className="!no-underline !text-black hover:!text-emerald-500"
                    to="/"
                  >
                    Home
                  </Link>
                </li>
                <li className="text-sm mt-[1px]">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </li>
                <li className="text-sm pr-1 transition duration-200 ease-in cursor-pointer  font-semibold">
                  {product?.parent}
                </li>
                <li className="text-sm mt-[1px]">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </li>
                <li className="text-sm px-1 transition duration-200 ease-in ">
                  {product?.title}
                </li>
              </ol> */}
            </div>
            <div className="w-full rounded-lg pt-3 bg-white">
              <div className="flex flex-col xl:flex-row">
                <div className="  flex-shrink-0 xl:pr-10 lg:block w-full mx-auto md:w-6/12 lg:w-5/12 xl:w-6/12">
                <div className="relative">

                 {product.price > 0 && product.originalPrice > product.price && (
  <span className="absolute text-dark text-xs bg-orange-500 text-white py-1 px-2 rounded font-medium z-10 right-4 top-4">
    {Math.round(
      ((product.originalPrice - product.price) / product.originalPrice) * 100
    )}
    % OFF
  </span>
)}
</div>

                  <div className="flex">
                    {/* Thumbnails (Left Side) */}
                  <div className="flex flex-col space-y-2 mr-4">
  {Array.isArray(product?.image) &&
    product.image.map((img, index) => (
      <img
        key={index}
        src={img}
        alt={`${product?.title} - ${index + 1}`}
        className={`w-[80px] h-[80px] rounded-lg object-cover cursor-pointer border ${
          selectedImage === img ? "border-blue-500" : "border-gray-300"
        }`}
        onClick={() => setSelectedImage(img)}
        crossOrigin={img.includes("api.pufframa.com") ? "anonymous" : undefined}
      />
    ))}
</div>


                    {/* Main Image (Right Side) */}
                   
                    <div className="flex-grow">
  <img
    src={selectedImage}
    alt={product?.title}
    className="w-[500px] h-[500px] object-cover rounded-lg border border-gray-300"
    crossOrigin={selectedImage.includes('api.pufframa.com') ? 'anonymous' : undefined}
  />
</div>

                  </div>
                </div>
                <div className="w-full">
                  <div className="flex flex-col md:flex-row lg:flex-row xl:flex-row">
                    <div className=" md:w-9/12 md:pr-4 lg:pr-4 xl:pr-12">
                      <div className="mb-6">
                        <h1 className="leading-7 text-lg md:text-xl lg:text-2xl mb-1 font-semibold text-gray-800">
                          {product?.title}
                        </h1>
                      </div>
                      <div className="product font-bold">
                        {data.price === 0 ? (
                          // ✅ Show only original price if price is 0
                          <span className="inline-block text-lg font-semibold text-gray-800">
                            ${data.originalPrice}
                          </span>
                        ) : (
                          <>
                            <span className="inline-block text-lg font-semibold text-gray-800">
                              ${data.price}
                            </span>
                            {data.price !== data.originalPrice && (
                              <del className="sm:text-sm font-normal text-base text-gray-400 ml-1">
                                ${data.originalPrice}
                              </del>
                            )}
                          </>
                        )}
                      </div>

                      <div className="mb-4 md:mb-5 block">
                        {product?.quantity !== 0 && (
                          <span className="bg-emerald-100 text-emerald-600 rounded-full inline-flex items-center justify-center px-2 py-1 text-xs font-semibold mt-2 ">
                            In Stock
                          </span>
                        )}
                        {product?.quantity === 0 && (
                          <span className="bg-red-100 text-red-600 rounded-full inline-flex items-center justify-center px-2 py-1 text-xs font-semibold  mt-2">
                            Stock Out
                          </span>
                        )}
                      </div>
                      <div>
                        <p className="text-md leading-6 text-gray-700 md:leading-7 font-Rubik font-normal">
                          {plainDescription2 || plainDescription}
                        </p>
                        {product?.nicotineLevel &&
                          product.nicotineLevel.trim() && (
                            <>
                              <p className="text-lg leading-6 text-gray-700 md:leading-7 font-Rubik font-bold">
                                Select Nicotine Level
                              </p>
                              <select
                                className="border rounded-md px-4 py-2 text-gray-700 mt-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                value={selectedNicotineLevel} 
                                onChange={handleNicotineLevelChange}
                              >
                               

                                <option value="">Choose an option</option>
                                {product?.nicotineLevel
                                  ?.split(",")
                                  .map((level, index) => {
                                    const trimmedLevel = level.trim();
                                    return (
                                      <option key={index} value={trimmedLevel}>
                                        {trimmedLevel}
                                      </option>
                                    );
                                  })}
                              </select>
                            </>
                          )}
{Array.isArray(product?.attributes) && product.attributes.length > 0 && (
  <div className="mt-6 space-y-4">
    <h2 className="text-lg font-semibold text-gray-800">Choose Options</h2>
    {product.attributes.map((attr, index) => (
      <div key={index}>
        <label className="block mb-1 text-sm font-medium text-gray-700">
          {attr.name}
        </label>
        <select
          className="border rounded-md px-4 py-2 text-gray-700 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={selectedAttributes[attr.name] || ""}
          onChange={(e) =>
            setSelectedAttributes({
              ...selectedAttributes,
              [attr.name]: e.target.value,
            })
          }
        >
          <option value="">Choose an option</option>
          {Array.isArray(attr.value) &&
            attr.value.map((val, idx) => (
              <option key={idx} value={val}>
                {val}
              </option>
            ))}
        </select>
      </div>
    ))}
  </div>
)}

                        <div className="flex items-center mt-4">
                          <div className="flex items-center justify-between space-s-3 sm:space-s-4 w-full">
                            <div className="group flex items-center justify-between rounded-md overflow-hidden flex-shrink-0 border h-11 md:h-12 border-gray-300">
                              <button
                                onClick={() => setTotal(total - 1)}
                                disabled={total <= 1 ? true : false}
                                className="flex items-center justify-center flex-shrink-0 h-full transition ease-in-out duration-300 focus:outline-none w-8 md:w-12 text-heading border-e border-gray-300 hover:text-gray-500"
                              >
                                <span className="text-dark text-base">
                                  <svg
                                    stroke="currentColor"
                                    fill="none"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                  </svg>
                                </span>
                              </button>
                              <p className="font-semibold flex items-center justify-center h-full transition-colors duration-250 ease-in-out cursor-default flex-shrink-0 text-base text-heading w-8 md:w-20 xl:w-24">
                                {total}
                              </p>
                              <button
                                disabled={
                                  product?.quantity === 0 ? true : false
                                }
                                onClick={() => {
                                  setTotal(total + 1);
                                }}
                                className="flex items-center justify-center h-full flex-shrink-0 transition ease-in-out duration-300 focus:outline-none w-8 md:w-12 text-heading border-s border-gray-300 hover:text-gray-500"
                              >
                                <span className="text-dark text-base">
                                  <svg
                                    stroke="currentColor"
                                    fill="none"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                  </svg>
                                </span>
                              </button>
                            </div>
                            <button
                              disabled={product?.quantity === 0 ? true : false}
                              onClick={() => handleAddToCart(product)}
                              className="text-sm leading-4 inline-flex items-center cursor-pointer transition ease-in-out duration-300 font-semibold text-center justify-center border-0 border-transparent rounded-md focus-visible:outline-none focus:outline-none text-white px-4 ml-4 md:px-6 lg:px-8 py-4 md:py-3.5 lg:py-4 hover:text-white bg-emerald-500 hover:bg-emerald-600 w-full h-12"
                            >
                              Add To Cart
                            </button>
                          </div>
                        </div>
                        <div className="flex flex-col mt-4">
                          <span className=" font-semibold py-1 text-sm d-block">
                                <p className="text-gray-700">
                              SKU :{" "}
                              <span className="font-bold text-gray-500">
                                {product?.sku}
                              </span>
                            </p>
                           
<div className="flex items-center gap-2 flex-wrap mb-4">
  
  <span className="text-gray-700 font-semibold ">Category:</span>
  {product?.parent?.split(',').map((cat, index) => (
    <span
      key={index}
      className="inline-block bg-gray-200 text-gray-800 px-2 py-1 rounded text-sm "
    >
      {cat.trim()}
    </span>
  ))}
</div>



                        
                            <p className="text-gray-700 flex flex-wrap items-center gap-2">
  <span className="font-semibold">Tags:</span>
  {tags?.map((tag, index) => (
    <span
      key={index}
      className="inline-block bg-gray-200 text-gray-800 px-2 py-1 rounded text-sm"
    >
      {tag}
    </span>
  ))}
</p>

                            {/* <span className="text-gray-700">
                              Child Category:{" "}
                            </span> */}
                            <span className="text-gray-500">
                              {product?.children}
                            </span>
                          </span>

                          <SocialNetwork />
                        </div>
                      </div>
                    </div>
                    <Informations />
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="pt-10 llg:pt-20 lg:pb-10">
            <h3 className="leading-7 text-lg lg:text-xl mb-3 font-semibold  hover:text-gray-600">
              Related Products
            </h3>
            <div className="flex">
              <div className="w-full">
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-6 gap-2 md:gap-3 lg:gap-3 ">
                  {RelatedProduct?.map((data, index) => (
                    <Card key={index} data={data} />
                  ))}
                </div>
              </div>
            </div>
          </div> */}
          </div>
        </div>
      )}
      <div className="bg-gray-50 ">
        <div className="mx-auto px-3 lg:px-10 max-w-screen-2xl">
          {sanitizedDescription.length > 0 && (
            <div className="bg-white p-6 rounded-lg ">
              <h2 className="text-3xl font-semibold text-gray-900 mb-10 underline">
                Product Description
              </h2>
              <div
                className="text-gray-900 leading-6 text-lg"
                dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Product;

